import {
    FetchIsTweetBookmarkedAdditionalInfoActionInterface,
    FetchTweetAdditionalInfoActionInterface,
    FetchVeracityInfoActionInterface,
    ResetTweetAdditionalInfoActionInterface,
    SetBlockedTweetAdditionalInfoActionInterface,
    SetFollowedTweetAdditionalInfoActionInterface,
    SetIsTweetBookmarkedAdditionalInfoActionInterface,
    SetMutedTweetAdditionalInfoActionInterface,
    SetTweetAdditionalInfoActionInterface,
    SetTweetAdditionalInfoLoadingStateActionInterface,
    TweetAdditionalInfoType,
    SetVeracityTweetInfoLoadingStateActionInterface,
    SetVeracityTweetListActionInterface,
    SetVeracityErrorMessageStateActionInterface
} from "./contracts/actionTypes";
import { SetVeracityTweetInfoState, TweetAdditionalInfoState, VeracityTweetInfoState } from "./contracts/state";
import { LoadingStatus } from "../../../types/common";

export const setTweetAdditionalInfo = (payload: TweetAdditionalInfoState["tweetAdditionalInfo"]): SetTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.SET_TWEET_ADDITIONAL_INFO,
    payload
});

export const fetchTweetAdditionalInfo = (payload: string): FetchTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.FETCH_TWEET_ADDITIONAL_INFO,
    payload
});

export const setMutedTweetAdditionalInfo = (payload: boolean): SetMutedTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.SET_MUTED_TWEET_ADDITIONAL_INFO,
    payload
});

export const setBlockedTweetAdditionalInfo = (payload: boolean): SetBlockedTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.SET_BLOCKED_TWEET_ADDITIONAL_INFO,
    payload
});

export const setFollowedTweetAdditionalInfo = (payload: boolean): SetFollowedTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.SET_FOLLOWED_TWEET_ADDITIONAL_INFO,
    payload
});

export const fetchIsTweetBookmarkedAdditionalInfo = (payload: string): FetchIsTweetBookmarkedAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.FETCH_IS_TWEET_BOOKMARKED_ADDITIONAL_INFO,
    payload
});

export const setIsTweetBookmarkedAdditionalInfo = (payload: boolean): SetIsTweetBookmarkedAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.SET_IS_TWEET_BOOKMARKED_ADDITIONAL_INFO,
    payload
});

export const resetTweetAdditionalInfo = (): ResetTweetAdditionalInfoActionInterface => ({
    type: TweetAdditionalInfoType.RESET_TWEET_ADDITIONAL_INFO_STATE
});

export const setTweetAdditionalInfoLoadingState = (payload: LoadingStatus): SetTweetAdditionalInfoLoadingStateActionInterface => ({
    type: TweetAdditionalInfoType.SET_TWEET_ADDITIONAL_INFO_LOADING_STATE,
    payload
});

export const fetchVeracityInfo = (payload: VeracityTweetInfoState): FetchVeracityInfoActionInterface => ({
  type: TweetAdditionalInfoType.FETCH_VERACITY_TWEET_INFO,
  payload
});

export const setVeracityTweetInfoLoadingState = (payload: LoadingStatus): SetVeracityTweetInfoLoadingStateActionInterface => ({
  type: TweetAdditionalInfoType.SET_VERACITY_TWEET_INFO_LOADING_STATE,
  payload
});

export const setVeracityTweetList = (payload: SetVeracityTweetInfoState): SetVeracityTweetListActionInterface => ({
  type: TweetAdditionalInfoType.SET_VERACITY_TWEET_LIST,
  payload
});

export const setVeracityErrorMessage = (payload: string): SetVeracityErrorMessageStateActionInterface => ({
    type: TweetAdditionalInfoType.SET_VERACITY_ERROR_MESSAGE_STATE,
    payload
});